import { Injectable } from '@angular/core';
import {
  BatchStatus,
  BatchTotalType,
  IBatchSearchViewModelBatchTotalTypePagedResultResponse,
  IBatchTotalTypeITotal,
} from '@services/cleanfill-api/cleanfill-api.generated';
import { BatchStatusExcludeTDP } from '@view-models/enums/batch-status.enum';
import { IBatchStatusOverview } from '@view-models/interfaces/batch-status-overview';

@Injectable({
  providedIn: 'root',
})
export class BatchMapperService {
  constructor() {}

  batchStatusEnumtoArray() {
    return Object.keys(BatchStatusExcludeTDP)
      .filter((key) => isNaN(Number(key)))
      .map((key) => BatchStatusExcludeTDP[key]);
  }

  getLabel(status: BatchStatus): string {
    switch (status) {
      case BatchStatus.New:
        return 'New';
      case BatchStatus.Draft:
        return 'Draft';
      case BatchStatus.FillSitePending:
        return 'Pending: Receiving Site';
      case BatchStatus.FillSiteInReview:
        return 'In Review: Receiving Site';
      case BatchStatus.FillSiteRejected:
        return 'Rejected: Receiving Site';
      case BatchStatus.QPPending:
        return 'Pending: Qualified Person';
      case BatchStatus.QPInReview:
        return 'In Review: Qualified Person';
      case BatchStatus.QPRejected:
        return 'Rejected: Qualified Person';
      case BatchStatus.TPQPApproved:
        return 'Approved: 3rd Party Qualified Person';
      case BatchStatus.BatchExtraPending:
        return 'Pending: Extra Load Request';
      case BatchStatus.TPQPPending:
        return 'Pending: 3rd Party Qualified Person';
      case BatchStatus.TPQPInReview:
        return 'In Review: 3rd Party Qualified Person';
      case BatchStatus.TPQPRejected:
        return 'Rejected: 3rd Party Qualified Person';
      case BatchStatus.Approved:
        return 'Approved';
      case BatchStatus.Inprogress:
        return 'In Progress';
      case BatchStatus.Complete:
        return 'Complete';
      case BatchStatus.Archive:
        return 'Archive';
      case BatchStatus.BatchExtraPending:
        return 'Pending: Batch Extra';
    }
  }

  translateBatchStatusOverview(
    overview: IBatchSearchViewModelBatchTotalTypePagedResultResponse,
    listType: 'all' | 'myBatches' | 'archive'
  ): IBatchStatusOverview {
    const totals = overview.totals;
    let totalSum = this.getBatchStatusMetric(totals, BatchTotalType.AllStatus);
    if (listType === 'all' || listType === 'myBatches') {
      totalSum = totalSum - this.getBatchStatusMetric(totals, BatchTotalType.Archive);
    }
    return {
      completed: this.getBatchStatusMetric(totals, BatchTotalType.Completed),
      approvedRequests: this.getBatchStatusMetric(totals, BatchTotalType.Approved),
      inProgressRequests: this.getBatchStatusMetric(totals, BatchTotalType.Inprogress),
      pendingRequests: this.getBatchStatusMetric(totals, BatchTotalType.PendingRequest),
      rejectedRequests: this.getBatchStatusMetric(totals, BatchTotalType.Rejected),
      draftRequests: this.getBatchStatusMetric(totals, BatchTotalType.Draft),
      totalSum,
    };
  }

  getBatchStatusMetric(metrics: IBatchTotalTypeITotal[], status: BatchTotalType): number {
    if (!metrics) {
      return 0;
    }

    const metric = metrics.find((m) => m.type === status);
    return metric?.value || 0;
  }
}
